import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Users from '../views/Users.vue'
import Rules from '../views/Rules.vue'
import Groups from '../views/Groups.vue'
import Funds from '../views/Funds.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', redirect: 'users' },
        { path: 'users', component: Users, meta: { title: '用户管理' } },
        { path: 'rules', component: Rules, meta: { title: '玩法管理' } },
        { path: 'groups', component: Groups, meta: { title: '群聊管理' } },
        { path: 'funds', component: Funds, meta: { title: '资金明细' } }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/')
  } else {
    next()
  }
})

export default router
